import React from 'react';
import { InventoryItem } from './InventoryItem';
import { GlobalHotKeys } from 'react-hotkeys';

class Inventory extends React.Component {
  state = {
    displayInventory: true,
  };

  callback = (childData) => {
    this.props.prevProps.coins =
      this.props.prevProps.coins +
      childData.data.value * childData.data.basePrice;
    this.props.prevProps.weight.current =
      this.props.prevProps.weight.current - childData.data.weight;
    childData.data.value = 0;
    childData.data.weight = 0;
    this.props.callback(childData);
  };

  renderInventory = () => {
    const { inventory } = this.props.redux;
    let inventoryTemplate = null;
    if (Object.keys(inventory).length) {
      inventoryTemplate = Object.keys(inventory).map(
        function (item, index) {
          return (
            <InventoryItem
              key={index}
              name={item}
              data={inventory[item]}
              redux={this.props.redux}
            />
          );
        }.bind(this)
      );
    } else {
      inventoryTemplate = null;
    }
    return inventoryTemplate;
  };

  toggleInventory = (event) => {
    event.preventDefault();
    if (this.state.displayInventory) {
      this.setState({
        displayInventory: false,
      });
    } else {
      this.setState({
        displayInventory: true,
      });
    }
  };

  onDrop = (event) => {
    event.preventDefault();
    let data = JSON.parse(event.dataTransfer.getData('text/plain'));
    console.log(data);
    const { prevProps } = this.props;
    this.setState(data, () => {
      if (prevProps.inventory[data.name].value < data.data.value) {
        ++prevProps.inventory[data.name].value;
        --prevProps.inventory[data.name].properties.amountPlaced;
        prevProps.energy = prevProps.energy - data.data.properties.generation;
        this.props.callback(this.props.prevProps);
      }
    });
  };

  onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    console.log('ondragover inventory');
  };

  render() {
    const keyMap = {
      TOGGLE_INVENTORY: ['e', 'у'],
    };
    const handlers = {
      TOGGLE_INVENTORY: this.toggleInventory,
    };
    return (
      <React.Fragment>
        <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
        <div
          className={
            this.state.displayInventory ? 'inventory open' : 'inventory'
          }
          onDrop={this.onDrop}
          onDragOver={this.onDragOver}
        >
          <div className="inventory__container">{this.renderInventory()}</div>
        </div>
      </React.Fragment>
    );
  }
}

export { Inventory };
